export default __webpack_public_path__ + "static/logo-emblem-basic-74645c9e707243856ebfa7957eb762af.svg";